import { render, staticRenderFns } from "./AddNewOrder.vue?vue&type=template&id=327b33ec&"
import script from "./AddNewOrder.vue?vue&type=script&lang=js&"
export * from "./AddNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOrder.vue?vue&type=style&index=0&id=327b33ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports